namespace Nbs.Xlr8PageTemplate {
  export function render() {
    Header.render();
    Footer.render();
    Menu.render();
  }

  export function hideMainNavigation() {
    Header.hideMenu();
    Menu.hide();
  }

  export function showMainNavigation() {
    Header.showMenu();
    Menu.show();
  }

  export function hideAllNavigation() {
    Header.hideMenu();
    Menu.hide();
    Footer.hideLinks();
  }

  export function showAllNavigation() {
    Header.showMenu();
    Menu.show();
    Footer.showLinks();
  }

  export function setNavigationClickHandler(clickHandler?: ((menuItem: Navigation.MenuItem) => boolean)) {
    Header.setMenuClickHandler(clickHandler);
    Menu.setMenuClickHandler(clickHandler);
    Footer.setLinksClickHandler(clickHandler);
  }

  export function setNonce(value?: string) {
    Theme.setNonce(value);
  }

  export function setDefaultContentWidth() {
    Utilities.removeClass(document.body, 'xpt-full-width')
  }

  export function setFullContentWidth() {
    Utilities.addClass(document.body, 'xpt-full-width')
  }
}
